(function () {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('jotApp')
        .factory('ObjectStatusService', ObjectStatusService);

    ObjectStatusService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q', 'STOMP_DEBUG'];

    function ObjectStatusService($rootScope, $window, $cookies, $http, $q, STOMP_DEBUG) {
        var stompClient = null;
        var subscriber = [];
        var listener = $q.defer();
        var connected = $q.defer();
        var connectionId;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            init: init,
            sendChangePage: sendChangePage,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect() {
            //building absolute path so that websocket doesnt fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/object/status';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            if (STOMP_DEBUG === false)
                stompClient.debug = null;
            connectionId = guid();
            var headers = {};
            headers['X-CSRF-TOKEN'] = $cookies[$http.defaults.xsrfCookieName];
            stompClient.connect(headers, function () {
                connected.resolve('success');
            });

        }

        function disconnect() {
            if (stompClient !== null) {
                stompClient.disconnect();
                connected = $q.defer();
                stompClient = null;
            }
        }

        function receive() {
            return listener.promise;
        }

        function init() {
            return listener = $q.defer();
        }

        function sendChangePage(page) {
            if (stompClient !== null && stompClient.connected) {
                stompClient.send('/topic/object/page/' + connectionId, {}, angular.toJson(page));
            }
        }

        function subscribe(callback) {
            connected.promise.then(function () {
                subscriber = stompClient.subscribe('/topic/network/status/' + connectionId, function (data) {
                    listener.notify(angular.fromJson(data.body));
                }, {'id': connectionId});
                callback.call();
            }, null, null);

        }

        function unsubscribe() {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }

        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
            }

            return s4() + s4() + s4();
        }

    }
})();
